import { render, staticRenderFns } from "./checkPtClass.vue?vue&type=template&id=857177e4&scoped=true&"
import script from "./checkPtClass.vue?vue&type=script&lang=js&"
export * from "./checkPtClass.vue?vue&type=script&lang=js&"
import style0 from "./checkPtClass.vue?vue&type=style&index=0&id=857177e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857177e4",
  null
  
)

component.options.__file = "checkPtClass.vue"
export default component.exports